const skills = {
  // HeroSection
  'skills.hero.homeLink': 'Home',
  'skills.hero.aboutLink': 'About the Academy',
  'skills.hero.currentPage': 'Skills Map',
  'skills.hero.title': 'Skills Map',
  'skills.hero.titleEn': 'SKILLS',
  'skills.hero.lead': 'The skills required of a butler are organised into five domains and acquired systematically. Students build solid capability progressively — from foundational techniques through to management and leadership.',
  'skills.hero.imgAlt': 'Students refining their skills during training',

  // SkillsIntro
  'skills.intro.label': 'FIVE DOMAINS',
  'skills.intro.title': 'Five Skill Domains',
  'skills.intro.titleEn': 'Five Skill Domains',
  'skills.intro.description': 'The skills demanded of a butler are organised into five domains: technical service excellence, the observational ability to anticipate needs, dignified communication, the management capability to run a household, and the composure to handle any crisis — each one a capability that can only be truly acquired through sustained practice.',

  // SkillAreas
  'skills.area.skillsLabel': 'Skills Acquired',
  'skills.area.startLabel': 'Introduced in:',
  'skills.area.deepenLabel': 'Deepened in:',
  'skills.area.0.startCourse': 'Essential',
  'skills.area.0.deepenCourse': 'Advanced / Master',
  'skills.area.1.startCourse': 'Essential',
  'skills.area.1.deepenCourse': 'Advanced / Master',
  'skills.area.2.startCourse': 'Essential',
  'skills.area.2.deepenCourse': 'Advanced / Master',
  'skills.area.3.startCourse': 'Advanced',
  'skills.area.3.deepenCourse': 'Master',
  'skills.area.4.startCourse': 'Master',
  'skills.area.4.deepenCourse': 'Master',
  'skills.area.startCourse': 'Introduced in',
  'skills.area.deepenCourse': 'Deepened in',
  'skills.area.0.title': 'Service Skills',
  'skills.area.0.titleEn': 'Service Skills',
  'skills.area.0.subtitle': 'Table / Tea / Wine / Garment Care',
  'skills.area.0.description': 'The core practical skills of private household service. Students systematically acquire the techniques directly relevant to a butler\'s daily work — from table setting, tea service, and wine knowledge through to garment and linen management. The handling of clothing extends to the orders of formal dress themselves. In Britain from the later nineteenth into the early twentieth century, the morning coat spread as the gentleman\'s daytime dress and was taken up in the butler\'s own attire, becoming established as formal dress for the daytime; today it is still regarded as the most formal of daytime dress. Evening dress changes at about six o\'clock: the most formal is the tailcoat — a black tail coat worn with a white dress shirt, white waistcoat and white bow tie — while a step within it stands the dinner jacket, a black or midnight-blue jacket worn with a white dress shirt, black bow tie and trousers carrying a single braid down the side. The butler too changed his dress in the evening and put his appearance in order.',
  'skills.area.0.skill.0': 'Setting and clearing a formal table',
  'skills.area.0.skill.1': 'Brewing and serving black tea and Chinese tea by variety',
  'skills.area.0.skill.2': 'Wine fundamentals, tasting, and food pairing',
  'skills.area.0.skill.3': 'Fabric-specific garment and linen care and storage',
  'skills.area.0.skill.4': 'Identifying and handling cutlery and glassware',
  'skills.area.1.title': 'Observation & Anticipation',
  'skills.area.1.titleEn': 'Observation & Anticipation',
  'skills.area.1.subtitle': 'Situational Awareness / Anticipation / Attentiveness',
  'skills.area.1.description': 'Reading the intentions of employers and guests from the subtlest gestures and expressions, and acting before they need to ask — this is a core capability that no manual can fully convey, refined only through experience and training.',
  'skills.area.1.skill.0': 'Reading guest intent from gesture and expression',
  'skills.area.1.skill.1': 'Judging the right moment by reading the atmosphere of the room',
  'skills.area.1.skill.2': 'Anticipating and responding to unspoken wishes',
  'skills.area.1.skill.3': 'Adjusting the environment to suit the season and time of day',
  'skills.area.2.title': 'Communication',
  'skills.area.2.titleEn': 'Communication',
  'skills.area.2.subtitle': 'Language / Distance / Confidentiality / Dignity',
  'skills.area.2.description': 'The words and bearing of a butler shape the entire impression of the household. \n\nBeyond precise use of formal language, students develop the complete communication skill set — appropriate personal distance, strict confidentiality, and formal written and telephone correspondence.',
  'skills.area.2.skill.0': 'Selecting the appropriate register of formal and humble language for each situation',
  'skills.area.2.skill.1': 'Maintaining appropriate personal distance with guests',
  'skills.area.2.skill.2': 'Strict confidentiality and information management',
  'skills.area.2.skill.3': 'Formal written, email, and telephone correspondence',
  'skills.area.2.skill.4': 'Basic hospitality in multiple languages (English, Mandarin)',
  'skills.area.3.title': 'Management',
  'skills.area.3.titleEn': 'Management',
  'skills.area.3.subtitle': 'Household Administration / Scheduling / Staff Leadership',
  'skills.area.3.description': 'The butler is the operational head of a private household. Management capabilities are essential — from daily household administration and annual event scheduling to negotiating with external suppliers and leading a team of staff.',
  'skills.area.3.skill.0': 'Scheduling annual events and daily household operations',
  'skills.area.3.skill.1': 'Household budget management and reporting',
  'skills.area.3.skill.2': 'Overseeing external contractors (landscaping, maintenance, catering)',
  'skills.area.3.skill.3': 'Staff rota management and leadership',
  'skills.area.3.skill.4': 'Asset management (art, wine cellar, etc.)',
  'skills.area.4.title': 'Crisis Response',
  'skills.area.4.titleEn': 'Crisis Response',
  'skills.area.4.subtitle': 'Emergency Response / Calm Judgement / Safety',
  'skills.area.4.description': 'Students build the ability to respond to any emergency that may arise in a private household — calmly and precisely. \n\nFrom medical emergencies and natural disasters to security incidents, the professional butler must possess advanced crisis management capability.',
  'skills.area.4.skill.0': 'First response to medical emergencies',
  'skills.area.4.skill.1': 'Evacuation guidance during fire, earthquake, and other disasters',
  'skills.area.4.skill.2': 'Responding to intruders and security incidents',
  'skills.area.4.skill.3': 'Attending to the emotional needs of employer and guests during an incident',
  'skills.area.4.skill.4': 'Liaison procedures with relevant authorities (police, fire, medical)',

  // CourseSkillsTable
  'skills.table.label': 'BY COURSE',
  'skills.table.title': 'Skills Acquired by Course',
  'skills.table.titleEn': 'Skills by Course',
  'skills.table.description': 'The depth to which each domain is developed varies by course. Target outcomes are raised progressively — from foundational skills through management and crisis response. The main skills covered in each course are set out below.',
  'skills.table.viewDetail': 'Details',
  'skills.table.0.name': 'Essential',
  'skills.table.0.scope': 'Foundational techniques and basic service',
  'skills.table.0.details': 'Table setting, tea service, formal language fundamentals, and the foundations of observation. A complete introduction to the techniques and service basics that are the first step of butler practice.',
  'skills.table.1.name': 'Advanced',
  'skills.table.1.scope': 'Includes Essential, plus advanced service, wine, event management, international etiquette',
  'skills.table.1.details': 'Includes the foundational techniques from Essential, then adds wine service, formal dinner management, international etiquette, and introductory staff management. \n\nDeepening specialist expertise and building the capability to handle real-world professional demands.',
  'skills.table.2.name': 'Master',
  'skills.table.2.scope': 'Includes Essential and Advanced, plus management, crisis response, VIP service, leadership',
  'skills.table.2.details': 'Includes the full content of both Essential and Advanced, then adds integration of all domains, crisis management, dedicated VIP service, and staff leadership. Pursuing the highest standard of professional butler practice.',

  // AchievementGoals
  'skills.goals.label': 'TARGETS',
  'skills.goals.title': 'Achievement Targets',
  'skills.goals.titleEn': 'Achievement Targets',
  'skills.goals.description': 'The following sets out indicative achievement targets by course for each of the five skill domains. These represent the level aimed for upon completion — not guaranteed outcomes.',
  'skills.goals.domain.0': 'Service Skills',
  'skills.goals.domain.1': 'Observation & Anticipation',
  'skills.goals.domain.2': 'Communication',
  'skills.goals.domain.3': 'Management',
  'skills.goals.domain.4': 'Crisis Response',
  'skills.goals.course.0': 'Essential',
  'skills.goals.course.1': 'Advanced',
  'skills.goals.course.2': 'Master',
  'skills.goals.footerNote': '* These figures represent indicative achievement targets at the time of completion — not guaranteed outcomes.',

  // CertificationSection
  'skills.cert.label': 'CERTIFICATION',
  'skills.cert.title': 'Certifying Your Skills',
  'skills.cert.titleEn': 'Certifying Your Skills',
  'skills.cert.description': 'Skills acquired during the programme are formally recognised through the association certification awarded to those who pass the final practical assessment. \n\nGraduates receive an official certificate, providing independent proof of their professional expertise as a butler.',
  'skills.cert.note': '* This certification is awarded to graduates of the core courses (Essential / Advanced / Master) and is distinct from the attendance certificate issued for corporate training.',
  'skills.cert.viewLink': 'View Certification & Credential',
  'skills.cert.badge.title': 'Association Certification',
  'skills.cert.badge.subtitle': 'Awarded to graduates who pass the practical assessment',

  // FAQSection
  'skills.faq.label': 'FAQ',
  'skills.faq.title': 'Frequently Asked Questions',
  'skills.faq.titleEn': 'Frequently Asked Questions',
  'skills.faq.footer': 'For further enquiries, please use our',
  'skills.faq.footerContact': 'contact form',
  'skills.faq.footerSuffix': '.',
  'skills.faq.0.question': 'What skills will I learn?',
  'skills.faq.0.answer': 'Students build skills systematically across five domains: service skills, observation and anticipation, communication, management, and crisis response.',
  'skills.faq.1.question': 'Can I have my skills formally recognised?',
  'skills.faq.1.answer': 'Yes. Passing the practical assessment at the end of each course awards an official certification from The All Japan Butler Association.',
  'skills.faq.2.question': 'Can I develop these skills even with no prior experience?',
  'skills.faq.2.answer': 'Yes. The curriculum is designed to build skills progressively from the ground up, so even complete beginners can develop genuine competence at a natural pace.',

  // CTASection
  'skills.cta.label': 'NEXT STEP',
  'skills.cta.title': 'Confirm the Results of Your Learning',
  'skills.cta.body': 'See the certification programme that recognises the skills you have acquired, and explore the full range of courses. Or simply come and feel the atmosphere at a taster session.',
  'skills.cta.note': '* Online consultations are also available.',
  'skills.cta.certificate': 'View Certification & Credential',
  'skills.cta.courses': 'View Courses',
  'skills.cta.seminar': 'Try the Training at a Taster Session',

  // RelatedPages
  'skills.related.label': 'LEARN MORE',
  'skills.related.title': 'Related Pages',
  'skills.related.titleEn': 'Explore Further',
  'skills.related.viewLink': 'Learn more',
  'skills.related.0.title': 'Certification',
  'skills.related.0.desc': 'The association credential awarded on completion',
  'skills.related.1.title': 'Practical Training',
  'skills.related.1.desc': 'Hands-on training and role-play at the core of learning',
  'skills.related.2.title': 'Study Materials',
  'skills.related.2.desc': 'All 15 specialist textbooks supervised by the Association',
  'skills.related.3.title': 'Course Comparison',
  'skills.related.3.desc': 'Compare our three courses at a glance',

  // Last updated
  'skills.lastUpdated': 'Last updated: 8 July 2026',
};

export default skills;
